export const uploadedImageDefaultType = 'image/jpeg';

export const uploadedImageQuality = 0.8;

export const uploadedImageMaxSize = 1500; // In pixels
